<template>
  <div class="all_card_box">
    <div class="all_top_tit2">
        <div>{{$t("main.text782")}}</div>
        <div v-if="v_lan != 'en'">{{lang_en.main.text782}}</div>
    </div>
    <div class="zdy_table_list">
            <!-- 第一行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">
                    <div>{{$t("bank_card.Personal_Details")}}</div>
                    <div v-if="v_lan != 'en'">{{lang_en.bank_card.Personal_Details}}</div>
                </div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <!-- <el-form-item :label="$t('main.text579')"> -->
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text579")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text579}}</div>
                                </span>
                                <el-input disabled v-model="form.company_name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text518")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text518}}</div>
                                </span>
                                <el-select v-model="form.title" :disabled="[5].includes(op_status)" :placeholder="$t('main.text135')">
                                    <!-- Mr Ms Mrs -->
                                    <el-option :label="$t('main.text540')" value="Mr"></el-option>
                                    <el-option :label="$t('main.text541')" value="Ms"></el-option>
                                    <el-option :label="$t('main.text542')" value="Mrs"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text519")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text519}}</div>
                                </span>
                                <el-input :disabled="[3,5].includes(op_status)" v-model="form.first_name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text520")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text520}}</div>
                                </span>
                                <el-input :disabled="[3,5].includes(op_status)" v-model="form.last_name"></el-input>
                            </el-form-item>
                        </div>
                        
                    </div>
                    <!-- 3 -->
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text521")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text521}}</div>
                                </span>
                                <el-input :disabled="[2,3,4,5].includes(op_status)" :class="inp_err?'inp_err':''" @blur="verify_username" v-model="form.username" maxlength="10"></el-input>
                                <div v-if="inp_err" class="inp_err_txt">{{ inp_err_txt }}</div>
                            </el-form-item>
                        </div>
                        
                    </div>
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div><span v-if="v_lan != 'jp'">{{$t("main.text185")}}</span><span v-else>&nbsp;</span></div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text185}}</div>
                                </span>
                                <el-input v-model="form.email" :disabled="[5].includes(op_status)"></el-input>
                                <span v-if="!form.email">
                                    <span class="reg_code_btn_no">{{$t('main.text198')}}</span>
                                </span>
                                <span v-else>
                                    <span v-show="show" class="reg_code_btn" @click="send_email_btn">{{$t('main.text198')}}</span>
                                    <span v-show="!show" class="reg_code_btn_no">{{$t('main.text198')}}</span>
                                    <!-- <span v-show="show" class="reg_code_btn_no">{{$t('main.text198')}}({{count}})</span> -->
                                </span>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("bank_card.Enter_Code")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">{{$t("bank_card.Please_enter_OTP")}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.bank_card.Enter_Code}}</div>
                                </span>
                                <el-input :class="verifyCode_err?'inp_err':''" v-model.trim="form.email_code" :disabled="[5].includes(op_status)"></el-input>
                                <div v-if="verifyCode_err" class="inp_err_txt">{{ verifyCode_err_txt }}</div>
                                <span v-if="!form.email_code">
                                    <span class="reg_code_btn_no">{{$t("bank_card.Verify")}}</span>
                                </span>
                                <span v-else>
                                    <span class="reg_code_btn" v-if="!verifyCode_200" @click="verifyCode_btn">{{$t("bank_card.Verify")}}</span>
                                    <span class="reg_code_btn" v-else style="background: none;color: #00B700;">
                                        <i class="el-icon-success"></i>
                                    </span>
                                </span>

                            </el-form-item>
                        </div>
                    </div>

                    <div class="d_row">
                        
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text199")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text199}}</div>
                                </span>
                                <!-- <el-input v-model="form.mobile_number"></el-input> -->
                                <div class="code_w">
                                    <div class="code_w3">
                                        <el-select filterable v-model="form.calling_code" :disabled="[5].includes(op_status)" @change="phone_code_change" :placeholder="$t('main.text200')">
                                            <div v-for="(item,name) in code_json" :key="name">
                                                <el-option
                                                    v-for="(item,index) in item" :key="index"
                                                    :label="item.name"
                                                    :value="item.num">
                                                </el-option>
                                            </div>
                                        </el-select>
                                    </div>
                                    <div class="reg_code_box">
                                        <span class="calling_code_f">
                                            <span class="calling_code_span"><span v-if="form.calling_code">+</span>{{ form.calling_code }}</span>
                                            <el-input v-model.trim="form.mobile_number" :disabled="[5].includes(op_status)" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                                        </span>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text522")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text522}}</div>
                                </span>
                                <!-- 出生日期  现在可以选未来的日期。不应该选未来的日期 -->
                                <el-date-picker
                                    :disabled="[3,5].includes(op_status)"
                                    class="time_box"
                                    :editable="false"
                                    :popper-class="v_lan=='en'?'zdy_picker_en':'' "
                                    v-model="form.date_of_birth"
                                    type="date"
                                    :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                                    value-format="dd-MM-yyyy"
                                    :picker-options="pickerOptions"
                                    :placeholder="$t('main.text242')">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 4 -->
                    <div class="d_row">
                        
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("bank_card.Gender")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.bank_card.Gender}}</div>
                                </span>
                                <el-select v-model="form.gender" :disabled="[5].includes(op_status)" :placeholder="$t('main.text135')">
                                    <!-- Male Female -->
                                    <el-option :label="$t('bank_card.Male')" value="Male"></el-option>
                                    <el-option :label="$t('bank_card.Female')" value="Female"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text523")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text523}}</div>
                                </span>
                                <el-input :disabled="[3,5].includes(op_status)" v-model="form.card_name"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 5 -->
                    <div class="d_row">
                        
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text290")}} 1</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text290}}</div>
                                </span>
                                <el-input v-model="form.address" :disabled="[5].includes(op_status)"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text290")}}<span v-if="v_lan != 'ch'"> 2</span><span v-else>第二行</span>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text290}} 2</div>
                                </span>
                                <el-input v-model="form.secondary_address" :disabled="[5].includes(op_status)"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 6 -->
                    <div class="d_row">
                        
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text524")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text524}}</div>
                                </span>
                                <el-select :disabled="[5].includes(op_status)" filterable v-model="form.country" @change="form_country_fun" :placeholder="$t('main.text135')">
                                    <!-- <el-option v-for="(item,index) in code_json" :key="index" :label="item.name" :value="item.en_name+'-'+item.jc"></el-option> -->
                                
                                    <div v-for="(item,name) in code_json" :key="name">
                                        <el-option
                                            v-for="(item,index) in item" :key="index"
                                            :label="item.name"
                                            :value="item.en_name+'-'+item.jc">
                                        </el-option>
                                    </div>
                                
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text525")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text525}}</div>
                                </span>
                                <el-input v-model="form.state" :disabled="[5].includes(op_status)"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 7 -->
                    <div class="d_row">
                        
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text526")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text526}}</div>
                                </span>
                                <el-input v-model="form.city" :disabled="[5].includes(op_status)"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text527")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text527}}</div>
                                </span>
                                <el-input v-model="form.postal_code" :disabled="[5].includes(op_status)"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="two_submit_box">
                        <el-form-item class="width_auto">
                            <template v-if="authjson.authjson(['12-3'])&&op_status!=5">
                                <div class="continue_btn" @click="submit_member_info">
                                    {{$t('main.text36')}}
                                </div>
                            </template>
                        </el-form-item>
                    </div>
                    
                    <template>
                        <div style="margin-bottom: 10px;">{{$t("main.text145")}}</div>

                        <div class="d_row">
                            <div>
                                <el-form-item>
                                    <span slot="label">
                                        <div>{{$t("main.text290")}}<span v-if="v_lan != 'ch'"> 1</span><span v-else>第一行</span>
                                        </div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text290}} 1</div>
                                    </span>
                                    <el-input v-model="form.mail_address"></el-input>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item>
                                    <span slot="label">
                                        <div>{{$t("main.text290")}}<span v-if="v_lan != 'ch'"> 2</span><span v-else>第二行</span>
                                        </div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text290}} 2</div>
                                    </span>
                                    <el-input v-model="form.mail_secondary_address"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="d_row">
                            <div>
                                <el-form-item>
                                    <span slot="label">
                                        <div>{{$t("main.text524")}}</div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text524}}</div>
                                    </span>
                                    <el-select filterable v-model="form.mail_country" :placeholder="$t('main.text135')">
                                        <!-- <el-option v-for="(item,index) in code_json" :key="index" :label="item.name" :value="item.en_name+'-'+item.jc"></el-option> -->
                                    
                                        <div v-for="(item,name) in code_json" :key="name">
                                            <el-option
                                                v-for="(item,index) in item" :key="index"
                                                :label="item.name"
                                                :value="item.en_name">
                                            </el-option>
                                        </div>
                                    
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item :label="$t('main.text525')">
                                    <span slot="label">
                                        <div>{{$t("main.text525")}}</div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text525}}</div>
                                    </span>
                                    <el-input v-model="form.mail_state"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="d_row">
                            <div>
                                <el-form-item>
                                    <span slot="label">
                                        <div>{{$t("main.text526")}}</div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text526}}</div>
                                    </span>
                                    <el-input v-model="form.mail_city"></el-input>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item>
                                    <span slot="label">
                                        <div>{{$t("main.text527")}}</div>
                                        <div v-if="v_lan != 'en'">{{lang_en.main.text527}}</div>
                                    </span>
                                    <el-input v-model="form.mail_postal_code"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        
                        <div class="two_submit_box">
                            <el-form-item class="width_auto">
                                <template v-if="authjson.authjson(['12-3'])">
                                    <div class="continue_btn" @click="two_submit3">
                                        {{$t('main.text36')}}
                                    </div>
                                </template>
                            </el-form-item>
                        </div>

                    </template>
                    
                </el-form>

            </div>
            <!-- 第二行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">
                    <div>{{$t("bank_card.Proof_Identity")}}</div>
                    <div v-if="v_lan != 'en'">{{lang_en.bank_card.Proof_Identity}}</div>
                </div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text697")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text697}}</div>
                                </span>
                                <el-select :disabled="[2,4].includes(form.kyc_id_status)" v-model="form.id_type" :placeholder="$t('main.text135')">
                                    <el-option :label="$t('main.text698')" value="Passport"></el-option>
                                    <el-option :label="$t('main.text699')" value="National Id"></el-option>
                                    <el-option :label="$t('bank_card.Driver_License')" value="Driver License"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text529")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text529}}</div>
                                </span>
                                <el-input :disabled="[2,4].includes(form.kyc_id_status)" v-model="form.passport_number"></el-input>
                            </el-form-item>
                        </div>
                        
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text530")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">{{$t("bank_card.For_ID_Card")}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text530}}</div>
                                </span>
                                <el-date-picker
                                    :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="time_box"
                                    :editable="false"
                                    :popper-class="v_lan=='en'?'zdy_picker_en':'' "
                                    v-model="form.issued_date"
                                    type="date"
                                    :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                                    value-format="dd-MM-yyyy"
                                    :placeholder="$t('main.text242')">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text531")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">{{$t("bank_card.ID_Card_without")}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text531}}</div>
                                </span>
                                <el-date-picker 
                                    :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="time_box"
                                    :editable="false"
                                    :popper-class="v_lan=='en'?'zdy_picker_en':'' "
                                    v-model="form.expiration_date"
                                    type="date"
                                    :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                                    value-format="dd-MM-yyyy"
                                    :placeholder="$t('main.text242')">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <!-- 这块需要新加一个 KYC 签发国家 -->
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text617")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text617}}</div>
                                </span>
                                <el-select :disabled="[2,4].includes(form.kyc_id_status)" filterable v-model="form.issued_by" @change="issued_by_fun" :placeholder="$t('main.text617')">
                                   

                                    <div v-for="(item,name) in code_json" :key="name">
                                        <el-option
                                            v-for="(item,index) in item" :key="index"
                                            :label="item.name"
                                            :value="item.en_name+'-'+item.jc">
                                        </el-option>
                                    </div>

                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <!-- 语言 -->
                            <el-form-item>
                                <span slot="label">
                                    <div>{{$t("main.text578")}}</div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text578}}</div>
                                </span>
                                <el-select :disabled="[2,4].includes(form.kyc_id_status)" filterable v-model="form.language" @change="lang_change(form.language,'1')">
                                    <el-option :label="$t('main.text605')" value="English"></el-option>
                                    <el-option :label="$t('main.text606')" value="Spanish"></el-option>
                                    <el-option :label="$t('main.text607')" value="French"></el-option>
                                    <el-option :label="$t('main.text608')" value="Arabic"></el-option>
                                    <el-option :label="$t('main.text609')" value="Chinese"></el-option>
                                    <el-option :label="$t('main.text610')" value="Japanese"></el-option>
                                    <el-option :label="$t('main.text611')" value="Russian"></el-option>
                                    <el-option :label="$t('main.text612')" value="Portuguese"></el-option>
                                    <el-option :label="$t('main.text613')" value="German"></el-option>
                                    <el-option :label="$t('main.text614')" value="Italian"></el-option>
                                    <el-option :label="$t('main.text615')" value="Hindi"></el-option>
                                    <el-option :label="$t('main.text616')" value="Other"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <template v-if="form.language&&form.language!=='English' ">
                        <div>
                            <div class="lang_btn_txt1">{{$t("bank_card.Important_Please")}}</div>
                            <div class="lang_btn_txt2">{{$t("bank_card.If_you_are")}}</div>
                        </div>
                    </template>
                    <!-- 3 -->
                    <div class="d_row">
                        <div>
                            <el-form-item>
                                <div class="box_top_tit">
                                    <div>{{$t("main.text532")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">
                                                <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                <div>{{$t("bank_card.Allow_up_to")}}</div>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text532}}</div>
                                </div>
                                <el-upload
                                :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="1"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="fileList1"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="(file)=>{ossUpload_assistant(file,'1')}"
                                    :before-remove="(file)=>{child_beforeRemove(file,'1')}"
                                    multiple>
                                        <template v-if="!form.passport_front.length || !form.passport_front">
                                            <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                            <div class="el-upload__text upload_text">
                                                <div>{{$t('main.text88')}}</div>
                                                <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                <!-- <div>{{$t('main.text490')}}</div> -->
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="(form.passport_front).includes('.pdf')||(form.passport_front).includes('.PDF')">
                                                <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                            </template>
                                            <template v-else>
                                                <el-image @error="image_err(1)" style="width: 100%; height: 100%" :src="form.passport_front" fit="cover"></el-image>
                                            </template>
                                        </template>
                                </el-upload>
                                
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <div class="box_top_tit">
                                    <div>{{$t("main.text533")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">
                                                <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                <div>{{$t("bank_card.Allow_up_to")}}</div>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text533}}</div>
                                </div>
                                <el-upload
                                :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="1"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="fileList2"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="(file)=>{ossUpload_assistant(file,'2')}"
                                    :before-remove="(file)=>{child_beforeRemove(file,'2')}"
                                    multiple>
                                        <template v-if="!form.passport_back.length ||!form.passport_back">
                                            <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                            <div class="el-upload__text upload_text">
                                                <div>{{$t('main.text88')}}</div>
                                                <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                <!-- <div>{{$t('main.text490')}}</div> -->
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="(form.passport_back).includes('.pdf')||(form.passport_back).includes('.PDF')">
                                                <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                            </template>
                                            <template v-else>
                                                <el-image @error="image_err(2)" style="width: 100%; height: 100%" :src="form.passport_back" fit="cover"></el-image>
                                            </template>
                                        </template>
                                </el-upload>
                                <!-- <div v-if="form.passport_back&&form.passport_back[0]" @click="download_file(form.passport_back)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                    {{ form.passport_back }}
                                </div> -->
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 1 2 英文版 -->
                    <div class="d_row" v-if="form.language&&form.language!=='English' ">
                        <div>
                            <el-form-item>
                                <div class="box_top_tit">
                                    <div>{{$t("main.text532")}} {{$t("bank_card.label_in_English")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">
                                                <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                <div>{{$t("bank_card.Allow_up_to")}}</div>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text532}}</div>
                                </div>
                                <el-upload
                                :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="1"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="fileList5"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="(file)=>{ossUpload_assistant(file,'5')}"
                                    :before-remove="(file)=>{child_beforeRemove(file,'5')}"
                                    multiple>
                                        <template v-if="!form.passport_front_en.length ||!form.passport_front_en">
                                            <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                            <div class="el-upload__text upload_text">
                                                <div>{{$t('main.text88')}}</div>
                                                <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                <!-- <div>{{$t('main.text490')}}</div> -->
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="(form.passport_front_en).includes('.pdf')||(form.passport_front_en).includes('.PDF')">
                                                <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                            </template>
                                            <template v-else>
                                                <el-image @error="image_err(5)" style="width: 100%; height: 100%" :src="form.passport_front_en+''" fit="cover"></el-image>
                                            </template>
                                        </template>
                                </el-upload>
                                <!-- <div v-if="form.passport_front_en&&form.passport_front_en[0]" @click="download_file(form.passport_front_en)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                    {{ form.passport_front_en }}
                                </div> -->
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item>
                                <div class="box_top_tit">
                                    <div>{{$t("main.text533")}} {{$t("bank_card.label_in_English")}}
                                        <el-tooltip placement="top">
                                            <i class="el-icon-info warning_outline"></i>
                                            <div slot="content">
                                                <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                <div>{{$t("bank_card.Allow_up_to")}}</div>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div v-if="v_lan != 'en'">{{lang_en.main.text533}}</div>
                                </div>
                                <el-upload
                                :disabled="[2,4].includes(form.kyc_id_status)"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="1"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="fileList6"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="(file)=>{ossUpload_assistant(file,'6')}"
                                    :before-remove="(file)=>{child_beforeRemove(file,'6')}"
                                    multiple>
                                        <template v-if="!form.passport_back_en.length ||!form.passport_back_en">
                                            <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                            <div class="el-upload__text upload_text">
                                                <div>{{$t('main.text88')}}</div>
                                                <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                <!-- <div>{{$t('main.text490')}}</div> -->
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="(form.passport_back_en).includes('.pdf')||(form.passport_back_en).includes('.PDF')">
                                                <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                            </template>
                                            <template v-else>
                                                <el-image @error="image_err(6)" style="width: 100%; height: 100%" :src="form.passport_back_en+''" fit="cover"></el-image>
                                            </template>
                                        </template>
                                </el-upload>
                                <!-- <div v-if="form.passport_back_en&&form.passport_back_en[0]" @click="download_file(form.passport_back_en)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                    {{ form.passport_back_en }}
                                </div> -->
                            </el-form-item>
                        </div>
                    </div>

                    <div class="two_submit_box">
                        <el-form-item class="width_auto">
                        <!-- kyc_id_status  审核状态 0未提交；1提交未审核；2审核成功；3审核失败 -->
                        <template v-if="authjson.authjson(['12-3'])">
                            <div class="continue_btn" @click="two_submit1" v-if="[0,1,3].includes(form.kyc_id_status)">
                                {{$t('main.text36')}}
                            </div>
                        </template>
                        </el-form-item>
                    </div>
                </el-form>

            </div>

            <!-- 第三行数据 -->
            <div class="table_btm table_btm3">
                        <template v-if="form.address_language&&form.address_language!=='English' ">
                            <div>
                                <div class="lang_btn_txt1">{{$t("bank_card.Please_upload_English")}}</div>
                                <div class="lang_btn_txt2">{{$t("bank_card.If_you_are")}}</div>
                            </div>
                        </template>

                        <div class="table_btm_t1">
                            <div>{{$t("main.text534")}}</div>
                            <div v-if="v_lan != 'en'">{{lang_en.main.text534}}</div>
                        </div>
                    
                        <el-form class="step1_form zdy_form_style" label-position="top">
                            
                            <div class="d_row">
                                <div>
                                    <el-form-item class="f_item">
                                        <span slot="label">
                                            <div>{{$t("main.text576")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text576}}</div>
                                            <div>{{$t("bank_card.Please_ensure_that")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.bank_card.Please_ensure_that}}</div>
                                        </span>
                                        <el-select :disabled="[2,4].includes(form.kyc_address_status)" filterable v-model="form.address_type">
                                            <el-option :label="$t('main.text601')" :value="`Credit Card Statement`"></el-option>
                                            <el-option :label="$t('main.text602')" :value="`Utility Bill`"></el-option>
                                            <el-option :label="$t('main.text603')" :value="`Bank Statement`"></el-option>
                                            <el-option :label="$t('main.text604')" :value="`Bank Letter`"></el-option>
                                            <el-option :label="$t('bank_card.Insurance_Policy')" :value="`Insurance Policy`"></el-option>
                                            <el-option :label="$t('bank_card.Post_Balance')" :value="`Post Office Balance Certificate`"></el-option>
                                            <el-option :label="$t('bank_card.Other_Government')" :value="`Other Government Issued Document`"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item class="f_item">
                                        <span slot="label">
                                            <!-- {{$t('main.text535')}}<br/>
                                            {{$t('main.text544')}} -->
                                            <div>{{$t("main.text535")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">{{$t("bank_card.Issuing_authority")}}</div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text535}}</div>

                                            <div>{{$t("main.text544")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text544}}</div>
                                        </span>
                                        <el-input :disabled="[2,4].includes(form.kyc_address_status)" v-model="form.address_issued_by" oninput="value=value.replace(/[^a-zA-Z\s]/g,'')"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="d_row">
                                <div>
                                    <el-form-item class="f_item">
                                        <span slot="label">
                                            <!-- {{$t('main.text536')}}<br/>
                                            {{$t('main.text545')}} -->
                                            <div>{{$t("main.text536")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">{{$t("bank_card.Must_be_dated")}}</div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text536}}</div>

                                            <!-- <div>{{$t("main.text545")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text545}}</div> -->
                                        </span>
                                        <el-date-picker
                                            :disabled="[2,4].includes(form.kyc_address_status)"
                                            class="time_box"
                                            :editable="false"
                                            :popper-class="v_lan=='en'?'zdy_picker_en':'' "
                                            v-model="form.address_issued_date"
                                            type="date"
                                            :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                                            value-format="dd-MM-yyyy"
                                            :picker-options="pickerOptions_90"
                                            :placeholder="$t('main.text242')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item class="f_item">
                                        <span slot="label">
                                            <!-- {{$t('main.text621')}} -->
                                            <div>{{$t("main.text621")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text621}}</div>
                                        </span>
                                        <el-select :disabled="[2,4].includes(form.kyc_address_status)" filterable v-model="form.address_language" @change="lang_change(form.address_language,'2')">
                                            <el-option :label="$t('main.text605')" value="English"></el-option>
                                            <el-option :label="$t('main.text606')" value="Spanish"></el-option>
                                            <el-option :label="$t('main.text607')" value="French"></el-option>
                                            <el-option :label="$t('main.text608')" value="Arabic"></el-option>
                                            <el-option :label="$t('main.text609')" value="Chinese"></el-option>
                                            <el-option :label="$t('main.text610')" value="Japanese"></el-option>
                                            <el-option :label="$t('main.text611')" value="Russian"></el-option>
                                            <el-option :label="$t('main.text612')" value="Portuguese"></el-option>
                                            <el-option :label="$t('main.text613')" value="German"></el-option>
                                            <el-option :label="$t('main.text614')" value="Italian"></el-option>
                                            <el-option :label="$t('main.text615')" value="Hindi"></el-option>
                                            <el-option :label="$t('main.text616')" value="Other"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="d_row">
                                <div>
                                    <el-form-item>
                                        <div class="box_top_tit">
                                            <div>{{$t("main.text618")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">
                                                <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                <div>{{$t("bank_card.Allow_up_to")}}</div>
                                            </div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text618}}</div>
                                        </div>
                                        <el-upload
                                        :disabled="[2,4].includes(form.kyc_address_status)"
                                            class="upload-demo upload_box"
                                            drag
                                            :limit="1"
                                            action="#"
                                            ref="upload-file"
                                            :show-file-list="true"
                                            :file-list="fileList3"
                                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                            :http-request="(file)=>{ossUpload_assistant(file,'3')}"
                                            :before-remove="(file)=>{child_beforeRemove(file,'3')}"
                                            multiple>
                                                <template v-if="!form.address_proof_front.length ||!form.address_proof_front">
                                                    <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                                    <div class="el-upload__text upload_text">
                                                        <div>{{$t('main.text88')}}</div>
                                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                        <!-- <div>{{$t('main.text490')}}</div> -->
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="(form.address_proof_front).includes('.pdf')||(form.address_proof_front).includes('.PDF')">
                                                        <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                                    </template>
                                                    <template v-else>
                                                        <el-image @error="image_err(3)" style="width: 100%; height: 100%" :src="form.address_proof_front" fit="cover"></el-image>
                                                    </template>
                                                </template>
                                        </el-upload>
                                        <!-- <div v-if="form.address_proof_front&&form.address_proof_front[0]" @click="download_file(form.address_proof_front)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                            {{ form.address_proof_front }}
                                        </div> -->
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item>
                                        <div class="box_top_tit">
                                            <div>{{$t("main.text619")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">
                                                        <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                        <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                        <div>{{$t("bank_card.Allow_up_to")}}</div>
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text619}}</div>
                                        </div>
                                        <el-upload
                                        :disabled="[2,4].includes(form.kyc_address_status)"
                                            class="upload-demo upload_box"
                                            drag
                                            :limit="1"
                                            action="#"
                                            ref="upload-file"
                                            :show-file-list="true"
                                            :file-list="fileList4"
                                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                            :http-request="(file)=>{ossUpload_assistant(file,'4')}"
                                            :before-remove="(file)=>{child_beforeRemove(file,'4')}"
                                            multiple>
                                                <template v-if="!form.address_proof_back.length ||!form.address_proof_back">
                                                    <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                                    <div class="el-upload__text upload_text">
                                                        <div>{{$t('main.text88')}}</div>
                                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                        <!-- <div>{{$t('main.text490')}}</div> -->
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="(form.address_proof_back).includes('.pdf')||(form.address_proof_back).includes('.PDF')">
                                                        <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                                    </template>
                                                    <template v-else>
                                                        <el-image @error="image_err(4)" style="width: 100%; height: 100%" :src="form.address_proof_back" fit="cover"></el-image>
                                                    </template>
                                                </template>
                                        </el-upload>
                                        <!-- <div v-if="form.address_proof_back&&form.address_proof_back[0]" @click="download_file(form.address_proof_back)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                            {{ form.address_proof_back }}
                                        </div> -->
                                    </el-form-item>
                                </div>
                            </div>
                            <!-- 语言 英文版 -->
                            <div class="d_row" v-if="form.address_language&&form.address_language!=='English' ">
                                <div>
                                    <!-- <el-form-item v-for="(item,index) in corporate_fi" :key="index"> -->
                                    <el-form-item>
                                        <div class="box_top_tit">
                                            <div>{{$t("main.text619")}} {{$t("bank_card.label_in_English")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">
                                                        <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                        <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                        <div>{{$t("bank_card.Allow_up_to")}}</div>
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text618}}</div>
                                        </div>
                                        <el-upload
                                        :disabled="[2,4].includes(form.kyc_address_status)"
                                            class="upload-demo upload_box"
                                            drag
                                            :limit="1"
                                            action="#"
                                            ref="upload-file"
                                            :show-file-list="true"
                                            :file-list="fileList7"
                                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                            :http-request="(file)=>{ossUpload_assistant(file,'7')}"
                                            :before-remove="(file)=>{child_beforeRemove(file,'7')}"
                                            multiple>
                                                <template v-if="!form.address_proof_front_en.length || !form.address_proof_front_en">
                                                    <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                                    <div class="el-upload__text upload_text">
                                                        <div>{{$t('main.text88')}}</div>
                                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                        <!-- <div>{{$t('main.text490')}}</div> -->
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="(form.address_proof_front_en).includes('.pdf')||(form.address_proof_front_en).includes('.PDF')">
                                                        <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                                    </template>
                                                    <template v-else>
                                                        <el-image @error="image_err(7)" style="width: 100%; height: 100%" :src="form.address_proof_front_en+''" fit="cover"></el-image>
                                                    </template>
                                                </template>
                                        </el-upload>
                                        <!-- <div v-if="form.address_proof_front_en&&form.address_proof_front_en[0]" @click="download_file(form.address_proof_front_en)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                            {{ form.address_proof_front_en }}
                                        </div> -->
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item>
                                        <div class="box_top_tit">
                                            <div>{{$t("main.text619")}} {{$t("bank_card.label_in_English")}}
                                                <el-tooltip placement="top">
                                                    <i class="el-icon-info warning_outline"></i>
                                                    <div slot="content">
                                                        <div>{{$t("bank_card.Image_File_Type")}}</div>
                                                        <div>{{$t("bank_card.Image_Size_Limit")}}</div>
                                                        <div>{{$t("bank_card.Allow_up_to")}}</div>
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text619}}</div>
                                        </div>
                                        <el-upload
                                        :disabled="[2,4].includes(form.kyc_address_status)"
                                            class="upload-demo upload_box"
                                            drag
                                            :limit="1"
                                            action="#"
                                            ref="upload-file"
                                            :show-file-list="true"
                                            :file-list="fileList8"
                                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                            :http-request="(file)=>{ossUpload_assistant(file,'8')}"
                                            :before-remove="(file)=>{child_beforeRemove(file,'8')}"
                                            multiple>
                                                <template v-if="!form.address_proof_back_en.length || !form.address_proof_back_en">
                                                    <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                                    <div class="el-upload__text upload_text">
                                                        <div>{{$t('main.text88')}}</div>
                                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                        <!-- <div>{{$t('main.text490')}}</div> -->
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="(form.address_proof_back_en).includes('.pdf')||(form.address_proof_back_en).includes('.PDF')">
                                                        <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                                    </template>
                                                    <template v-else>
                                                        <el-image @error="image_err(8)" style="width: 100%; height: 100%" :src="form.address_proof_back_en+''" fit="cover"></el-image>
                                                    </template>
                                                </template>
                                        </el-upload>
                                        <!-- <div v-if="form.address_proof_back_en&&form.address_proof_back_en[0]" @click="download_file(form.address_proof_back_en)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                            {{ form.address_proof_back_en }}
                                        </div> -->
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="d_row">
                                <div>
                                    <el-form-item>
                                        <div class="box_top_tit">
                                            <div>{{$t("main.text157")}}</div>
                                            <div v-if="v_lan != 'en'">{{lang_en.main.text157}}</div>
                                        </div>
                                        <el-upload
                                        disabled
                                            class="upload-demo upload_box"
                                            drag
                                            :limit="3"
                                            action="#"
                                            ref="upload-file"
                                            :show-file-list="true"
                                            :file-list="fileList9"
                                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                            :http-request="(file)=>{ossUpload_assistant(file,'9')}"
                                            :before-remove="(file)=>{child_beforeRemove(file,'9')}"
                                            multiple>
                                                <template v-if="!form.address_proof_additional.length ||!form.address_proof_additional || !form.address_proof_additional[0]">
                                                    <img class="load_icon" src="../../assets/img/user_upload_img.png" alt="">
                                                    <div class="el-upload__text upload_text">
                                                        <div>{{$t('main.text88')}}</div>
                                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                                        <!-- <div>{{$t('main.text490')}}</div> -->
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="['.pdf','.PDF'].includes(form.address_proof_additional[0])">
                                                        <el-image style="width: 50%;height: 50%;top: 50%;transform: translateY(-50%);" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                                                    </template>
                                                    <template v-else>
                                                        <el-image @error="image_err(9)" style="width: 100%; height: 100%" :src="form.address_proof_additional[0]+''" fit="cover"></el-image>
                                                    </template>
                                                </template>
                                        </el-upload>
                                        <!-- <template v-if="form.address_proof_additional && form.address_proof_additional.length">
                                            <div v-for="(i,ind) in form.address_proof_additional" :key="ind">
                                                <div @click="download_file(i)" style="line-height: initial;cursor: pointer;color: #00bd9c;word-break: break-all;">
                                                {{ i }}
                                                </div>
                                            </div>
                                        </template> -->
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="two_submit_box">
                                <el-form-item class="width_auto">
                                <!-- kyc_address_status    地址审核状态 0未提交；1提交未审核；2审核成功；3审核失败 4 审核拒绝-->
                                <template v-if="authjson.authjson(['12-3'])">
                                    <div class="continue_btn" @click="two_submit2" v-if="[0,1,3].includes(form.kyc_address_status)">
                                        {{$t('main.text36')}}
                                    </div>
                                </template>
                                </el-form-item>
                            </div>
                            
                            <!-- <div class="two_submit_box">
                                <el-form-item class="width_auto">
                                    <div class="continue_btn" @click="two_submit">{{$t('main.text36')}}</div>
                                </el-form-item>
                            </div> -->

                        </el-form>
                        <div>
                            <div class="lang_btn_txt1">{{$t("bank_card.Notes")}}</div>
                            <div class="lang_btn_txt1" v-if="v_lan != 'en'">{{lang_en.bank_card.Notes}}</div>

                            <div class="lang_btn_txt2">1. {{$t("bank_card.Ensure_documents")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.Ensure_documents}}</div>

                            <div class="lang_btn_txt2">2. {{$t("bank_card.Submit_complete")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.Submit_complete}}</div>

                            <div class="lang_btn_txt2">3. {{$t("bank_card.Take_clear")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.Take_clear}}</div>

                            <div class="lang_btn_txt2">4. {{$t("bank_card.When_capturing")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.When_capturing}}</div>

                            <div class="lang_btn_txt2">5. {{$t("bank_card.Do_not_add")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.Do_not_add}}</div>

                            <div class="lang_btn_txt2">6. {{$t("bank_card.If_your_full")}}</div>
                            <div class="lang_btn_txt2 lang_btn_txt2_b" v-if="v_lan != 'en'">{{lang_en.bank_card.If_your_full}}</div>

                        </div>
                        <div class="inp_btm_notice">
                            <p class="inp_btm_notice_p1">{{$t("v_life.Privacy_Data")}}</p>
                            <p class="inp_btm_notice_p1" v-if="v_lan != 'en'">{{lang_en.v_life.Privacy_Data}}</p>
                            <p class="inp_btm_notice_p2">{{$t("v_life.We_your_privacy")}}</p>
                            <p class="inp_btm_notice_p2" v-if="v_lan != 'en'">{{lang_en.v_life.We_your_privacy}}</p>
                        </div>
            </div>

            
    </div>
  </div>
</template>

<script>
import {awsS3Auth,sendEmail,card_details,verifyCode,verifyUsername ,updateIdKycInfo,updateAddressKycInfo,updateAccountInfo,updateMemberInfo} from '@/api/api';
import * as EmailValidator from 'email-validator';
import AWS from 'aws-sdk';
import lang_ch from "@/language/ch";
import lang_en from "@/language/en";
import lang_jp from "@/language/jp";
export default {
    data() {
        return {
            v_lan:localStorage.getItem("language")||"en",
            lang_ch:lang_ch,
            lang_en:lang_en,
            lang_jp:lang_jp,
            form:{
                company_name:'',
                title: '',
                first_name: '',
                last_name: '',
                username: '',
                email: "",
                mobile_number: "",
                date_of_birth: "",
                card_name: "",
                address: "",
                country: "",
                state: "",
                city: "",
                postal_code: "",
                id_type:'',
                passport_number: "",
                issued_date: "",
                expiration_date: "",
                passport_front: [],
                passport_back: [],
                address_proof_front:[],
                address_proof_back:[],
                address_issued_by: "",
                address_issued_date: "",

                issued_by: "",//护照的签发地
                address_type: "",//地址证明文件
                calling_code: "",//国家码
                language:'',//语言
                address_language:'',//语言
                note:'',//Notes and optional / 备注 *这个输入框可以不需要填

                email_code:'',
                password:"",
                confirm_password:"",
                gender:"",
                secondary_address:"",

                // mail_address:"",
                mail_address:"",
                mail_secondary_address:"",
                mail_country:"",
                mail_state:"",
                mail_city:"",
                mail_postal_code:"",
                passport_front_en:[],// id language语言非英文 正面照片数组
                passport_back_en:[],// d language语言非英文 背面照片数组
                address_proof_front_en:[],// 地址 语言非英文 正面
                address_proof_back_en:[],// 地址语言非英文 背面
                
                address_proof_additional:[],//允许有些用户上传其他图片或pdf(多张),多张就显示一个通用的图片这个不是必须的

            },
            is_Same_address:true,
            inp_err:false,
            inp_err_api:false,
            inp_err_txt:"",
            verifyCode_err:false,
            verifyCode_err_api:false,
            verifyCode_200:false,
            verifyCode_err_txt:'',

            id: this.$route.query.id,
            card_id: this.$route.query.card_id,
            
            code_json:"",
            director_data:{},
            awsS3_data:'',

            fileList1:[],
            fileList2:[],
            fileList3:[],
            fileList4:[],
            fileList5:[],
            fileList6:[],
            fileList7:[],
            fileList8:[],

            fileList9:[],
            fileList9_id:[],
            
            mobile_num_jc:'',//手机号 国家码 简称
            country_jc:"",//Country of Residence 居住国家简称
            issued_by_jc: "",//护照的签发地 简称

            visible_lan:false,
            FirstPin: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            code_json2:"",
            // 今天之后日期不能选择 8.64e6 8.64e7
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now() - 8.64e6;
                }
            },
            // 日期只可以是90天以内的
            pickerOptions_90: {
                disabledDate(time) {
                    let curDate = (new Date()).getTime();
                    let three = 90 * 24 * 3600 * 1000;
                    let threeMonths = curDate - three;
                    return time.getTime() > Date.now() || time.getTime() < threeMonths;
                }
            },

            show: true,//60秒 倒计时
            count: '',
            timer: null,
            pwd_yes: require("../../assets/img/eye_no_b.png"),
            pwd_no: require("../../assets/img/eye_yes_b.png"),
            pwd_yes_hs: require("../../assets/img/eye_no.png"),
            pwd_no_hs: require("../../assets/img/eye_yes.png"),
            pwdType: true,
            pwdType2: true,

            image_success1:true,
            image_success2:true,
            image_success3:true,
            image_success4:true,
            image_success5:true,
            image_success6:true,
            image_success7:true,
            image_success8:true,
            image_success9:true,
            
            op_status: this.$route.query.op_status*1,
            // kyc_info_dab:1,
            // status 状态 0未提交 1Pending, 2processing, 3approved，4rejected, 5active , 6blocked 7kyc-approved; 8Cancelled；9Expired
            // status 状态 1 待处理 2 处理中 3 成功 4 失败 
            // status 1- 都可以编辑
            // status 2和4- 除username 外其他都可以编辑 
            // status 3- first_name last_name username date_of_birth card_name 不可编辑 别的可以编辑
            old_form:{},

        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
        this.bus.$off("all_err_return");
    },
    beforeMount() {
        this.op_status = this.$route.query.op_status*1;
    },
    mounted() {
        sessionStorage.setItem('top_title_name'," ");
        this.S3Auth();
        this.getCardDetails();
    },
    created() {
        if(this.v_lan=='ch'){
            this.code_json=require("@/assets/phone_code/num_area_ch2.json");
            this.code_json2=require("@/assets/phone_code/num_area_ch2.json");
        }else{
            this.code_json=require("@/assets/phone_code/num_area_en2.json");
            this.code_json2=require("@/assets/phone_code/num_area_en2.json");
        }
        if (this.code_json) {
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
                cityName[item] = [];
                this.code_json.forEach(el => {
                    //对比开头字母是否对应
                    // 做一个判断 中文时候不走
                    let first = el.py.substring(0, 1).toUpperCase();
                    if (first == item) {
                        cityName[item].push(el);
                    }
                });            
            });
            this.$nextTick(()=>{
                this.code_json = cityName;
            })
        }

    },
    methods: {
        // 两个语言
        two_lang(v){
            let str=""
            if(this.v_lan!=='jp'){
                str = this.lang_ch;
            }else{
                str = this.lang_jp;
            }
            return str["main"][v];
        },
        // 随机数
        createCode() {
            var code = "";
            var codeLength = 10;
            var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
            for (var i = 0; i < codeLength; i++) {
                var index = Math.floor(Math.random() * 9);
                code += random[index];
            }
            return code;
        },
        async S3Auth() {
            const res = await awsS3Auth();
            if (res.data.code == 200) {
                this.awsS3_data = res.data.data;
                //参数
                AWS.config.update({
                region: "ap-southeast-1",
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: this.awsS3_data.IdentityPoolId,
                    IdentityId: this.awsS3_data.IdentityId,
                    Logins: {
                    "cognito-identity.amazonaws.com": this.awsS3_data.Token,
                    },
                }),
                });
            }else{
                this.message.ismessage('error',res.data.msg);
            }
        },

        ossUpload_assistant(data,i){
            this.$store.state.aws_loading = true;
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            let url='';
            s3.putObject(params,(err)=>{
                if(err){
                    this.$store.state.aws_loading=false;
                    return this.message.ismessage('error',this.$t('bank_card.Upload_error'));
                }else{
                    url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
                    this.$store.state.aws_loading=false;
                    if(i){
                        if(i==1){
                            this.form.passport_front=url;
                            this.image_success1=true;
                        }else if(i==2){
                            this.form.passport_back=url;
                            this.image_success2=true;
                        }else if(i==3){
                            this.form.address_proof_front=url;
                            this.image_success3=true;
                        }else if(i==4){
                            this.form.address_proof_back=url;
                            this.image_success4=true;
                        }
                        // passport_front_en:[],// id language语言非英文 正面照片数组
                        // passport_back_en:[],// d language语言非英文 背面照片数组
                        // address_proof_front_en:[],// 地址 语言非英文 正面
                        // address_proof_back_en:[],// 地址语言非英文 背面
                        else if(i==5){
                            this.form.passport_front_en=url;
                            this.image_success5=true;
                        }else if(i==6){
                            this.form.passport_back_en=url;
                            this.image_success6=true;
                        }else if(i==7){
                            this.form.address_proof_front_en=url;
                            this.image_success7=true;
                        }else if(i==8){
                            this.form.address_proof_back_en=url;
                            this.image_success8=true;
                        }else if(i==9){
                            this.form.address_proof_additional.push(url);
                            this.fileList9_id.push(data.file.uid);
                            this.image_success9=true;
                        }
                       
                    }
                    
                }
            })

        },
        child_beforeRemove(file,i){
            if(file){
              
                if(i==1){
                    this.form.passport_front=[];
                    // this.image_success1=true;
                }else if(i==2){
                    this.form.passport_back=[];
                    // this.image_success2=true;
                }else if(i==3){
                    this.form.address_proof_front=[];
                    // this.image_success3=true;
                }else if(i==4){
                    this.form.address_proof_back=[];
                    // this.image_success4=true;
                }
                // passport_front_en:[],// id language语言非英文 正面照片数组
                // passport_back_en:[],// d language语言非英文 背面照片数组
                // address_proof_front_en:[],// 地址 语言非英文 正面
                // address_proof_back_en:[],// 地址语言非英文 背面
                if(i==5){
                    this.form.passport_front_en=[];
                    // this.image_success5=true;
                }else if(i==6){
                    this.form.passport_back_en=[];
                    // this.image_success6=true;
                }else if(i==7){
                    this.form.address_proof_front_en=[];
                    // this.image_success7=true;
                }else if(i==8){
                    this.form.address_proof_back_en=[];
                    // this.image_success8=true;
                }else if(i==9){
                    let list9_index=this.fileList9_id.findIndex(item=>item==file.uid);
                    this.fileList9_id.splice(list9_index,1);
                    this.form.address_proof_additional.splice(list9_index,1);
                    // this.image_success9=true;
                }
            }
        },
        getCardDetails() {
          card_details({ card_id: this.card_id }).then((res) => {
            if (res.data && res.data.code == 200) {
              this.form = res.data.data;
              if(this.form.password){
                this.form.confirm_password = this.form.password;
              }
              this.old_form = JSON.parse(JSON.stringify(res.data.data));
              //   图片下面列表按钮
                if(this.form.passport_front){
                    this.fileList1=this.set_item_url(this.form.passport_front);
                }
                if(this.form.passport_back){
                    this.fileList2=this.set_item_url(this.form.passport_back);
                }
                if(this.form.address_proof_front){
                    this.fileList3=this.set_item_url(this.form.address_proof_front);
                }
                if(this.form.address_proof_back){
                    this.fileList4=this.set_item_url(this.form.address_proof_back);
                }
                if(this.form.passport_front_en){
                    this.fileList5=this.set_item_url(this.form.passport_front_en);
                }
                if(this.form.passport_back_en){
                    this.fileList6=this.set_item_url(this.form.passport_back_en);
                }
                if(this.form.address_proof_front_en){
                    this.fileList7=this.set_item_url(this.form.address_proof_front_en);
                }
                if(this.form.address_proof_back_en){
                    this.fileList8=this.set_item_url(this.form.address_proof_back_en);
                }
            } else {
              this.message.ismessage('error',res.data.msg);
            }
          });
        },
        two_submit(){
            if(!this.form.title){
                return this.message.ismessage('error',this.$t('main.text546'));
            } 
            if(!this.form.first_name.trim()){
                return this.message.ismessage('error',this.$t('main.text547'));
            } 
            if(!this.form.last_name.trim()){
                return this.message.ismessage('error',this.$t('main.text548'));
            } 
            if(!this.form.username.trim()){
                return this.message.ismessage('error',this.$t('main.text549'));
            }
            // 正则验证 
            const reg =/^\w+$/;
            if(!reg.test(this.form.username)){
                return this.message.ismessage('error',this.$t('main.text672'));
            }
            if(!this.form.email){
                return this.message.ismessage('error',this.$t('main.text550'));
            }
            // 邮箱格式
            if (!EmailValidator.validate(this.form.email)) {
                return this.message.ismessage('error',this.$t('main.text453'));
            }

            if(!this.form.calling_code){
                return this.message.ismessage('error',this.$t('main.text574'));
            }
            if(!this.form.mobile_number){
                return this.message.ismessage('error',this.$t('main.text551'));
            } 
            if(!this.form.date_of_birth){
                return this.message.ismessage('error',this.$t('main.text552'));
            } 
            if(!this.form.card_name.trim()){
                return this.message.ismessage('error',this.$t('main.text553'));
            } 
            if(!this.form.address){
                return this.message.ismessage('error',this.$t('main.text554'));
            } 
            if(!this.form.country){
                return this.message.ismessage('error',this.$t('main.text555'));
            } 
            if(!this.form.state){
                return this.message.ismessage('error',this.$t('main.text556'));
            } 
            if(!this.form.city){
                return this.message.ismessage('error',this.$t('main.text557'));
            } 
            if(!this.form.postal_code){
                return this.message.ismessage('error',this.$t('main.text558'));
            } 
            if(!this.form.id_type){
                return this.message.ismessage('error',this.$t('main.text700'));
            } 
            if(!this.form.passport_number){
                return this.message.ismessage('error',this.$t('main.text559'));
            } 
            if(!this.form.issued_date){
                return this.message.ismessage('error',this.$t('main.text560'));
            } 
            if(!this.form.expiration_date){
                return this.message.ismessage('error',this.$t('main.text561'));
            }
            if(!this.form.issued_by){
                return this.message.ismessage('error',this.$t('main.text575'));
            }
            if(!this.form.language){
                return this.message.ismessage('error',this.$t('main.text578'));
            }
            if(this.form.passport_front.length==0){
                return this.message.ismessage('error',this.$t('main.text562'));
            } 
            if(this.form.passport_back.length==0){
                return this.message.ismessage('error',this.$t('main.text563'));
            } 
            if(this.form.address_proof_front.length==0){
                return this.message.ismessage('error',this.$t('main.text564'));
            }
            // if(this.form.address_proof_back.length==0){
            //     return this.message.ismessage('error',this.$t('main.text564'));
            // }
            if(!this.form.address_type){
                return this.message.ismessage('error',this.$t('main.text576'));
            }
            if(!this.form.address_issued_by){
                return this.message.ismessage('error',this.$t('main.text565'));
            } 
            if(!this.form.address_issued_date){
                return this.message.ismessage('error',this.$t('main.text566'));
            }
            if(!this.form.address_language){
                return this.message.ismessage('error',this.$t('main.text621'));
            }
            // console.log(this.form);

            // api新加
            // if(!this.form.email_code || !this.email_otp_ok){
            if(!this.form.email_code){
                return this.message.ismessage('error',this.$t("bank_card.Please_email_verif"));
            }
            if(!this.form.password){
                return this.message.ismessage('error',this.$t("bank_card.enter_PIN"));
            }
           
            if(!this.form.confirm_password){
                return this.message.ismessage('error',this.$t("bank_card.enter_pwd_verif"));
            }
            if(this.form.password !== this.form.confirm_password){
                return this.message.ismessage('error',this.$t("bank_card.pwd_not_match"));
            }
            if(!this.form.gender){
                return this.message.ismessage('error',this.$t("bank_card.Please_Gender"));
            }
            if(!this.is_Same_address){
                // mail_address 邮寄地址 1
                // mail_secondary_address 邮寄地址2
                // mail_country 邮寄国家
                // mail_city 邮寄城市
                // mail_state 邮寄地区
                // mail_postal_code 邮寄编码
                // if(!this.form.mail_address) this.message.ismessage('error',"邮寄地址 1");
                if(!this.form.mail_secondary_address) this.message.ismessage('error',this.$t("bank_card.mailing_address")+"2");
                if(!this.form.mail_country) this.message.ismessage('error',this.$t("bank_card.mail_country"));
                if(!this.form.mail_city) this.message.ismessage('error',this.$t("bank_card.mail_city"));
                if(!this.form.mail_state) this.message.ismessage('error',this.$t("bank_card.mail_state"));
                if(!this.form.mail_postal_code) this.message.ismessage('error',this.$t("bank_card.mail_postal_code"));
            }
            if(this.form.language&&this.form.language!=='English'){
                // passport_front_en: id language语言非英文 正面照片数组
                // passport_back_en d language语言非英文 背面照片数组
                if(this.form.passport_front_en.length<=0 || this.form.passport_back_en.length<=0){
                    return this.message.ismessage('error',this.$t("bank_card.upload_file_first"));
                }
            }
            if(this.form.address_language&&this.form.address_language!=='English'){
                // address_proof_front_en 地址 语言非英文 正面
                // address_proof_back_en 地址语言非英文 背面
                if(this.form.address_proof_front_en.length<=0 || this.form.address_proof_back_en.length<=0){
                    return this.message.ismessage('error',this.$t("bank_card.upload_file_first"));
                }
            }
            if(!this.inp_err_api){
                return this.message.ismessage('error',this.$t("bank_card.Verify_name_first"));
            }
            if(!this.verifyCode_err_api){
                return this.message.ismessage('error',this.$t("bank_card.verify_email_first"));
            }

            localStorage.setItem("two_form_data",JSON.stringify(this.form));
            // 第三步接口要用
            // 居住的国家缩写 CH
            sessionStorage.setItem("country_code_3",this.country_jc);
            // this.mobile_num_jc
            // calling_code 国家码对应的国家缩写
            sessionStorage.setItem("calling_country_code_3",this.mobile_num_jc);
            // issued_by 简称
            sessionStorage.setItem("issued_by_short_name_3",this.issued_by_jc);
            this.$router.push('/all_apply_card_info');
        },
        phone_code_change(v){
            // console.log(v);
            for (let i = 0; i < this.code_json2.length; i++) {
                if(this.code_json2[i].num==v){
                    this.mobile_num_jc=this.code_json2[i].jc;
                }
            }
            
            this.form.calling_country_code = this.mobile_num_jc;
        },
        form_country_fun(v){
            let str =v.split("-");
            this.form.country=str[0];
            this.country_jc=str[1];
            this.form.country_code = str[1];
        },
        issued_by_fun(v){
            let str =v.split("-");
            this.form.issued_by=str[0];
            this.issued_by_jc=str[1];
            
        },
        lang_fun(v) {
            localStorage.setItem("language", v);
            setTimeout(() => {
                location.reload();
            }, 100);
        },
        set_item_url(item_url){
            let url=[];
            let str1 = item_url;
            let str2 = str1.split("/");
            url.push({name:str2[5],url:item_url});
            return url;
        },
        send_email_btn(){
            if (this.form.email=='') {
                this.message.ismessage('error',this.$t('main.text204'));
                return false;
            }
            sendEmail({
                email:this.form.email,
                type:'submitApply',
                card_level_name:this.card_level_name,
                userid:sessionStorage.getItem("userid"),
            }).then(res=>{
                if(res.data.code==207){
                this.$message.success(res.data.msg);
                this.getCode();
                this.email_otp_ok=true;
                this.verifyCode_200=false;
                }else{
                this.message.ismessage('error',res.data.msg);
                this.email_otp_ok=false;
                }
            })
        },
        getCode(){
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                }
                }, 1000)
            }
        },
        async verifyCode_btn(){
            if(!this.form.email_code){
                return this.message.ismessage('error',this.$t("bank_card.Please_email_verif"));
            }
            const res = await verifyCode({
                email:this.form.email,
                email_code:this.form.email_code
            });
            if (res.data.code == 200) {
                this.verifyCode_err=false;
                this.verifyCode_err_api=true;
                this.verifyCode_200=true;
                this.verifyCode_err_txt="";
                return this.message.ismessage('success',this.$t("bank_card.Email_verification"));
            }else{
                this.verifyCode_err=true;
                this.verifyCode_err_api=false;
                this.verifyCode_200=false;
                this.verifyCode_err_txt=res.data.msg;
                return this.message.ismessage('error',res.data.msg);
            }
        },
        async verify_username(){
            if(this.form.username){
                const res = await verifyUsername({
                    username:this.form.username
                });
                if (res.data.code == 200) {
                    this.inp_err=false;
                    this.inp_err_api=true;
                    this.inp_err_txt="";
                    return this.message.ismessage('success',this.$t("bank_card.name_succeeded"));
                }else{
                    this.inp_err=true;
                    this.inp_err_api=false;
                    this.inp_err_txt=res.data.msg;
                    return this.message.ismessage('error',res.data.msg);
                }
            }
            
        },
        image_err(v){
            if(v){
                this['image_success'+v]=false;
                return this.message.ismessage('error',this.$t('bank_card.There_problem_image'));
            }
        },
        two_submit1(){
            if(
                !this.image_success5||
                !this.image_success6||
                !this.image_success1||
                !this.image_success2
            ){
                return this.message.ismessage('error',this.$t('bank_card.There_problem_image'));
            }
            if(!this.form.id_type){
                return this.message.ismessage('error',this.$t('main.text700'));
            }
            if(!this.form.passport_number){
                return this.message.ismessage('error',this.$t('main.text559'));
            } 
            if(!this.form.issued_date){
                return this.message.ismessage('error',this.$t('main.text560'));
            } 
            if(!this.form.expiration_date){
                return this.message.ismessage('error',this.$t('main.text561'));
            }
            if(!this.form.issued_by){
                return this.message.ismessage('error',this.$t('main.text575'));
            }
            
            if ( this.form.passport_front.length <= 0 ) {
                return this.message.ismessage( "error", this.$t("bank_card.upload_file_first") );
            }
            if(this.form.id_type!=="Passport"){
                if ( this.form.passport_back.length <= 0) {
                    return this.message.ismessage("error",this.$t("bank_card.upload_file_first"));
                }
            }

            if (this.form.passport_front_en.length <= 0) {
                return this.message.ismessage("error",this.$t("bank_card.upload_file_first"));
            }
            if(this.form.id_type!=="Passport"){
                if ( this.form.passport_back_en.length <= 0 ) {
                    return this.message.ismessage( "error", this.$t("bank_card.upload_file_first") );
                }
            }

            updateIdKycInfo({
                card_id: this.card_id,
                id_type:this.form.id_type,
                passport_number:this.form.passport_number,
                issued_by:this.form.issued_by,
                issued_date:this.form.issued_date,
                expiration_date:this.form.expiration_date,
                language:this.form.language,
                passport_front:[this.form.passport_front],
                passport_back:[this.form.passport_back],
                passport_front_en:[this.form.passport_front_en],
                passport_back_en:[this.form.passport_back_en],
                }).then(res=>{
                if(res.data.code==200){
                    this.message.ismessage("success",res.data.msg);
                    this.$router.go(-1);
                }else{
                    this.message.ismessage("error",res.data.msg);
                }
            })
        },
        two_submit2(){
            if(
                !this.image_success7||
                !this.image_success8||
                !this.image_success3||
                !this.image_success4
            ){
                return this.message.ismessage('error',this.$t('bank_card.There_problem_image'));
            }
            if(!this.form.address_type){
                return this.message.ismessage('error',this.$t('main.text576'));
            }
            if(!this.form.address_issued_by){
                return this.message.ismessage('error',this.$t('main.text565'));
            } 
            if(!this.form.address_issued_date){
                return this.message.ismessage('error',this.$t('main.text566'));
            }
            if (this.form.address_proof_front_en.length <= 0) {
                return this.message.ismessage("error",this.$t("bank_card.upload_file_first"));
            }
            if (this.form.address_proof_front.length <= 0) {
                return this.message.ismessage("error",this.$t("bank_card.upload_file_first"));
            }
            updateAddressKycInfo({
                card_id: this.card_id,
                address_type:this.form.address_type,
                address_issued_by:this.form.address_issued_by,
                address_issued_date:this.form.address_issued_date,
                address_language:this.form.address_language,
                address_proof_front_en:[this.form.address_proof_front_en],
                address_proof_back_en:[this.form.address_proof_back_en],
                address_proof_front:[this.form.address_proof_front],
                address_proof_back:[this.form.address_proof_back],
                }).then(res=>{
                if(res.data.code==200){
                    this.message.ismessage("success",this.$t("main.text215"));
                    this.$router.go(-1);
                }else{
                    this.message.ismessage("error",res.data.msg);
                }
            })
        },
        two_submit3(){
            if(!this.form.mail_address){
            return this.message.ismessage('error',this.$t("bank_card.mailing_address") + "1");
            }
            if (!this.form.mail_secondary_address){
            return this.message.ismessage("error",this.$t("bank_card.mailing_address") + "2");
            }
            if (!this.form.mail_country){
            return this.message.ismessage("error", this.$t("bank_card.mail_country"));
            }
            if (!this.form.mail_city){
            return this.message.ismessage("error", this.$t("bank_card.mail_city"));
            }
            if (!this.form.mail_state){
            return this.message.ismessage("error", this.$t("bank_card.mail_state"));
            }
            if (!this.form.mail_postal_code){
            return this.message.ismessage("error",this.$t("bank_card.mail_postal_code"));
            }

            updateAccountInfo({
                username: this.form.username,
                mail_address: this.form.mail_address,
                mail_secondary_address: this.form.mail_secondary_address,
                mail_city: this.form.mail_city,
                mail_state: this.form.mail_state,
                mail_country: this.form.mail_country,
                mail_postal_code: this.form.mail_postal_code,
            }).then(res=>{
            if(res.data.code==200){
                this.message.ismessage("success",this.$t("main.text215"));
                this.$router.go(-1);
            }else{
                this.message.ismessage("error",res.data.msg);
            }
            })


        },
        download_file(v){
        window.open(v , "_blank");
        },
        // 提交KYC信息
        async submit_member_info(){
            if(!this.form.title){
                return this.message.ismessage('error',this.$t('main.text546'));
            } 
            if(!this.form.first_name.trim()){
                return this.message.ismessage('error',this.$t('main.text547'));
            } 
            if(!this.form.last_name.trim()){
                return this.message.ismessage('error',this.$t('main.text548'));
            }
            if(!this.form.username.trim()){
                return this.message.ismessage('error',this.$t('main.text549'));
            }
            // 正则验证 
            const reg =/^\w+$/;
            if(!reg.test(this.form.username)){
                return this.message.ismessage('error',this.$t('main.text672'));
            }
            if(!this.form.email){
                return this.message.ismessage('error',this.$t('main.text550'));
            }
            // 邮箱格式
            if (!EmailValidator.validate(this.form.email)) {
                return this.message.ismessage('error',this.$t('main.text453'));
            }
            if(this.old_form.email != this.form.email){
                if(!this.form.email_code){
                    return this.message.ismessage('error',this.$t('bank_card.Please_email_verif'));
                }
            }
            // if(!this.form.password){
            //     return this.message.ismessage('error',this.$t("bank_card.enter_PIN"));
            // }
            // if(!this.form.confirm_password){
            //     return this.message.ismessage('error',this.$t("bank_card.enter_pwd_verif"));
            // }
            // if(this.form.password !== this.form.confirm_password){
            //     return this.message.ismessage('error',this.$t("bank_card.pwd_not_match"));
            // }
            if(!this.form.calling_code){
                return this.message.ismessage('error',this.$t('main.text574'));
            }
            if(!this.form.mobile_number){
                return this.message.ismessage('error',this.$t('main.text551'));
            }
            
            if(!this.form.date_of_birth){
                return this.message.ismessage('error',this.$t('main.text552'));
            }
            if(!this.form.gender){
                return this.message.ismessage('error',this.$t("bank_card.Please_Gender"));
            }
            if(!this.form.card_name.trim()){
                return this.message.ismessage('error',this.$t('main.text553'));
            } 
            if(!this.form.address){
                return this.message.ismessage('error',this.$t('main.text554'));
            } 
            if(!this.form.country){
                return this.message.ismessage('error',this.$t('main.text555'));
            } 
            if(!this.form.state){
                return this.message.ismessage('error',this.$t('main.text556'));
            }
            if(!this.form.city){
                return this.message.ismessage('error',this.$t('main.text557'));
            }
            
            const info_data = {
                card_id : this.card_id,
                first_name : (this.form.first_name==this.old_form.first_name)?this.old_form.first_name:this.form.first_name,
                last_name : (this.form.last_name==this.old_form.last_name)?this.old_form.last_name:this.form.last_name,
                username : (this.form.username==this.old_form.username)?this.old_form.username:this.form.username,
                country_code : (this.form.country_code==this.old_form.country_code)?this.old_form.country_code:this.form.country_code,
                email : (this.form.email==this.old_form.email)?this.old_form.email:this.form.email,
                date_of_birth : (this.form.date_of_birth==this.old_form.date_of_birth)?this.old_form.date_of_birth:this.form.date_of_birth,
                calling_code : (this.form.calling_code==this.old_form.calling_code)?this.old_form.calling_code:this.form.calling_code,
                mobile_number : (this.form.mobile_number==this.old_form.mobile_number)?this.old_form.mobile_number:this.form.mobile_number,
                calling_country_code : (this.form.calling_country_code==this.old_form.calling_country_code)?this.old_form.calling_country_code:this.form.calling_country_code,
                title : (this.form.title==this.old_form.title)?this.old_form.title:this.form.title,
                state : (this.form.state==this.old_form.state)?this.old_form.state:this.form.state,
                city : (this.form.city==this.old_form.city)?this.old_form.city:this.form.city,
                postal_code : (this.form.postal_code==this.old_form.postal_code)?this.old_form.postal_code:this.form.postal_code,
                address : (this.form.address==this.old_form.address)?this.old_form.address:this.form.address,
                secondary_address : (this.form.secondary_address==this.old_form.secondary_address)?this.old_form.secondary_address:this.form.secondary_address,
                // password : (this.form.password==this.old_form.password)?this.old_form.password:this.form.password,
                // confirm_password : (this.form.confirm_password==this.old_form.confirm_password)?this.old_form.confirm_password:this.form.confirm_password,
                email_code : (this.form.email_code==this.old_form.email_code)?this.old_form.email_code:this.form.email_code,
                card_name : (this.form.card_name==this.old_form.card_name)?this.old_form.card_name:this.form.card_name,
                gender : (this.form.gender==this.old_form.gender)?this.old_form.gender:this.form.gender,
            };
            const res = await updateMemberInfo(info_data);

            if(res.data.code!=200){
                return this.message.ismessage('error',res.data.msg);
            }
            this.message.ismessage("success",this.$t("main.text215"));
            if(res.data.data==1){
                // 这个接口 返回值 data 是0或者1，1的话需要退出登录
                // 加一下这个 1的话就是改了 用户名 邮箱 手机号 密码这些需要退出登录
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push("/login");
            }else{
                this.$router.go(-1);
            }

        },
        lang_change(v,ind){
            if(ind==1){
                if(v=='English'){
                    this.form.passport_front_en=[];
                    this.form.passport_back_en=[];
                    this.fileList5=[];
                    this.fileList6=[];
                }
            }else if(ind==2){
                if(v=='English'){
                    this.form.address_proof_front_en=[];
                    this.form.address_proof_back_en=[];
                    this.fileList7=[];
                    this.fileList8=[];
                }
            }
        }



    },

    
}
</script>

<style scoped>
/* 表格 */
.list_title1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.list_table{
    display: block;
    width: 100%;
}
.list_table>div{
    width: 100%;
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list_table>div:nth-child(odd){
    background: #39526F;
    border-radius: 12px;
}
.list_table>div>div{
    /* min-width: 130px; */
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
}
.list_table div .td1{
    width: 25%;
}
.list_table div .td2{
    width: 25%;
    word-wrap: break-word;
}
.list_table div .td3{
    width: 25%;
}
.list_table div .td4{
    width: 25%;
}
.list_table .text_r{
    text-align: right;
}
.list_table .el-checkbox{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.list_table >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#fff;
    border-color:#fff;
    box-shadow: 0px 0px 0px 2px #39526F inset;
}
.list_table >>> .el-checkbox__inner{
    border-radius: 50%;
    background: transparent;
    width: 24px;
    height: 24px;
}
.list_table >>> .el-checkbox__inner::after{
    display: none;
}
.zdy_table_list{
    background: #314B69;
    border-radius: 16px;
}
.table_btm{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
}
.table_btm2{
    box-sizing: border-box;
    padding: 28px;
}
.table_btm_t1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.add_btn,
.add_btn:hover,
.add_btn:focus,
.add_btn:active{
    min-width: 300px;
    height: 44px;
    color: #DEB981;
    background: transparent;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}
.sand_img{
    width: 20px;
    cursor: pointer;
    vertical-align: middle;
}
.edit_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #FFFFFF;
    margin-bottom: 10px;
    cursor: pointer;
}
.delete_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #F35F65;
    cursor: pointer;
}
/* ---- */
.shuxian{
    width: 3px;
    margin: 20px 28px;
}
.d_row{
    display: flex;
    justify-content: space-between;
    align-items: end;
}
.d_row>div{
    width: 48%;
}
.table_btm3{
    padding-bottom: 6px;
}
.sc_ntb{
    min-width: 260px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #DEB981;
    cursor: pointer;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}
.width_auto{
    width: auto;
}
.xingx_img{
    width: 18px;
    margin-right: 13px;
    vertical-align: middle;
}
.inp_btm_txt{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 8px;
} 
.continue_btn{
    cursor: pointer;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #04182A;
    min-width: 224px;
    height: 38px;
    text-align: center;
    line-height: 38px;
}
.no_data_text{
    text-align: center;
    display: inherit;
}
/* ------ */
/* 日期 */
.time_box{
  width: 100%;
}
/* ------ */

/* 上传 列表 样式 */
.el-upload-list__item:hover {
  background: none;
  border: 1px solid #F5F7FA;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus, .el-upload-list__item.is-success .el-upload-list__item-name:hover{
  color: #fff;
}
.el-upload-list__item:hover .el-icon-close {
  color: #fff;
}
.el-icon-close-tip{
  display: none;
}
.focusing{
  display: none;
}

</style>

<style scoped>
/* --上传-- */
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_t_logo{
    width: 230px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
    margin-top: 40px;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 60px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(255, 255, 255, 0.6);
}
.upload_btn{
    border-color: #F1C788;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 18px; */
    color: #04182A;
    margin: 12px auto;
    height: 38px;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    /* opacity: 0.6; */
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #DEB981;
    border: 1px solid #DEB981;
    cursor: pointer;
    margin: 30px auto;
    box-shadow: 0px 2px 4px rgb(222 185 129 / 20%);
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #04182A;
    margin-bottom: 30px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_body >>> .el-upload-list__item .el-icon-close-tip{
    display: none !important;
    color: transparent;
}

/* --over-- */
/* 手机号 国家码 */
.code_w{
  display: flex;
}
.code_w3{
  margin-right: 16px;
  width: 280px;
}
.code_w3 span{
  background: #000;
}
.reg_code_box{
  width: 74%;
}
/* ------ */
.all_card_box{
    background: #041E35;
    box-sizing: border-box;
    padding-bottom: 60px;
    color: #fff;
}
.all_top{
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #041728;
    position: relative;
}
.all_top_logo{
    max-width: 200px;
}
.zdy_table_list{
    box-sizing: border-box;
    margin: 0 60px;
}
.all_top_tit{
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    box-sizing: border-box;
    margin: 60px 200px 40px;
}

/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: rgb(222, 185, 129);
}
.top_right_box1{
  /* margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px; */
  position: absolute;
  right: 40px;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
    color: rgb(222, 185, 129);
}
.lan_list_item{
    cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
/* .top_right_box1 > span{
  border: 1px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;

} */

/* ------ */
.all_top_tit2{
    font-size: 16px;
    margin: 20px 60px 20px;
}
.f_item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
.f_item >>> .el-form-item__label{
    flex: 1;
}
.f_item >>> .el-form-item__content{
    margin-bottom: 15px;
}

.reg_code_btn{
  position: absolute;
  right: 5px;
  top: 5px;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #fff;
  line-height: initial;
  cursor: pointer;
}
.reg_code_btn_no{
  position: absolute;
  right: 5px;
  top: 5px;
  background: #405c85;
  /* opacity: 0.2; */
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: 15px;
  color: #c5c5c5;
  line-height: initial;
  /* cursor: pointer; */
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.table_btm >>> .el-checkbox__label {
    color: #fff;
}
.warning_outline{
    cursor: pointer;
    margin-left: 5px;
}
.lang_btn_txt1{
    font-size: 14px;
    margin-bottom: 5px;
}
.lang_btn_txt2{
    font-size: 13px;
    margin-bottom: 10px;
}
.two_submit_box{
    text-align: center;
    margin-top: 10px;
}
.inp_err_txt{
    color: red;
    line-height: initial;
    margin-top: 8px;
    font-size: 12px;
}
.inp_err >>> .el-input__inner{
    border: 1px solid red;
}
.my_checkbox >>> .el-form-item__content{
    line-height: inherit;
}
.my_checkbox_div{
    padding-left: 25px;
    margin-bottom: 10px;
}
.lang_btn_txt2_b{
    padding-left: 13px;
}
.calling_code_f{
    position: relative;
}
.calling_code_f >>> .el-input__inner {
    text-indent: 2.7em;
}
.calling_code_span{
    position: absolute;
    left: 7px;
    z-index: 1;
    color: #fff;
}

.zdy_form_style >>> .el-input.is-disabled .el-input__inner {
    background: #E4E7ED !important;
    color: #000 !important;
}
.inp_btm_notice{
    margin-top: 20px;
    font-size: 13px;
}
.inp_btm_notice p{
    margin-bottom: 8px;
}
.d_row >>> .el-upload-list {
    height: 25.19px;
    margin-top: 10px;
}
</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  transform: translateX(-3px);
}
/* ---- */
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
    .d_row {
        display: block;
    }
    .d_row>div {
        width: auto;
    }
    .zdy_form_style >>> .el-form-item__label {
        height: auto !important;
    }
    .top_right_box1 {
        right: 27px;
    }
    .all_top_tit {
        margin: 20px;
    }
    .zdy_table_list {
        margin: 20px;
    }
    .all_top_tit2 {
        margin: 20px 20px 20px;
    }
    .reg_code_box{
        width: 77%;
    }

}
</style>
